import { ArraySerializer, Field, Model, PrimitiveSerializer, Type } from 'serialize-ts';
import { ModelMetadataSerializer } from 'serialize-ts/dist/serializers/model-metadata.serializer';

@Model()
export class EnergyConfigRange {
  @Field()
  max: string;
  @Field()
  min: string;
}
@Model()
export class energyEfficiencyLabelConfig {
  @Field()
  @Type(new ArraySerializer(new PrimitiveSerializer()))
  attributes: string[];
  @Field()
  defaultAttribute: string;
  @Field()
  @Type(new ModelMetadataSerializer(EnergyConfigRange))
  range: EnergyConfigRange;
  @Field()
  @Type(new ArraySerializer(new PrimitiveSerializer()))
  values: string[];
  @Field()
  version: number;
}
@Model()
export class EnergyConfig {
  @Field()
  energy_efficiency_class: string;
  @Field()
  @Type(new ModelMetadataSerializer(energyEfficiencyLabelConfig))
  energy_efficiency_label_config: energyEfficiencyLabelConfig;
  @Field()
  energy_efficiency_class_washing?: string;
  @Field()
  energy_efficiency_class_washing_drying?: string;
  @Field()
  energy_efficiency_class_cooling?: string;
  @Field()
  energy_efficiency_class_heating?: string;
}
